import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {MdbRippleModule} from "mdb-angular-ui-kit/ripple";
import { NgClass, NgStyle } from "@angular/common";
import {RouterLink} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-mdb-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    MdbRippleModule,
    RouterLink,
    TranslateModule,
    NgStyle,
    NgClass
],
    templateUrl: './mdb-button.component.html',
    standalone: true,
    styleUrl: './mdb-button.component.scss'
})
export class MdbButtonComponent {
  /** Button label (translation key or text). */
  text = input<string | undefined>();
  iconClass = input<string | undefined>();
  iconPosRight = input<boolean | undefined>(false);
  color = input<string>('primary');
  /** Size: 'sm' | 'lg' | undefined (default: medium). */
  size = input<string | undefined>();
  // rippleColor = input<string|undefined>("light")
  outlined = input<boolean | undefined>(false);
  floating = input<boolean | undefined>(false);
  customClasses = input('');
  routerLink = input<string | undefined>();
  loading = input<boolean | undefined>(false);
  isSubmit = input<boolean | undefined>(false);
  styles = input<{ [klass: string]: any }>({});
  disabled = input<boolean>(false);
  rounded = input<boolean>(false);
  lowercase = input<boolean>(false);

  onClick = output<any>();

  handleClick(event: Event) {
    if (!this.disabled() && !this.loading()) {
      this.onClick.emit(event);
    }
  }
}
